import { useState, useCallback } from 'react';

export default function useToggle(initialValue = false): [boolean, () => void] {
  const [value, setValue] = useState(initialValue);
  const toggleValue = useCallback(() => {
    setValue((value) => !value);
  }, []);
  return [value, toggleValue];
}
